import React from 'react';

import FormikSelect from 'src/components/formik/FormikSelect';
import {
  Step
} from 'src/types';
import CRUDConfigForm from 'src/components/formik/CRUDConfigForm';
import FormikInput from 'src/components/formik/FormikInput';
import { HTTP_METHOD_OPTIONS } from 'src/views/constants/otherConstants';

interface Props {
  step: Step,
}

const HttpRequestForm = ({ step }: Props) => {
  const fieldsConfig = [
    {
      name: 'url',
      component: () => (
        <FormikInput
          fullWidth
          label="URL"
          name="url"
        />
      ),
    },
    {
      name: 'httpMethod',
      component: () => (
        <FormikSelect
          fullWidth
          label="Role"
          name="httpMethod"
          options={HTTP_METHOD_OPTIONS}
        />
      ),
    },
    {
      name: 'payload',
      component: () => (
        <FormikInput
          fullWidth
          label="Payload"
          name="payload"
        />
      ),
    },
  ];

  return (
    <CRUDConfigForm
      url={`/automatic/workflows/${step.workflowId}/http-requests/`}
      objectId={step.action && step.action.httpRequest && step.action.httpRequest.id}
      fieldsConfig={fieldsConfig}
    />
  );
};

export default HttpRequestForm;
